import * as React from 'react';

import {UnlockCompaniesButton} from '../visitors/unlock-companies/unlock-companies-button';

import styles from './list-footer.module.css';

type CompanyListItem = {
    id: string;
    fields: {
        unlockTime: {
            value: string | null | undefined;
        };
    };
};

type Props = {
    selectedCompanies: CompanyListItem[];
    resetSelection: () => void;
    getRef: (arg1?: HTMLElement | null | undefined) => void;
};

export function CompanyListFooter(props: Props) {
    const unlockableCompanyIds = props.selectedCompanies
        .filter((company) => !company.fields.unlockTime.value)
        .map((company) => company.id);

    return (
        <div ref={props.getRef} className={styles.container}>
            <UnlockCompaniesButton
                selectedCompanyIds={unlockableCompanyIds}
                afterUnlock={props.resetSelection}
            />
            {unlockableCompanyIds && unlockableCompanyIds.length > 0 ? (
                <span className={styles['selected-count']}>
                    {unlockableCompanyIds.length} unlocked{' '}
                    {unlockableCompanyIds.length === 1 ? 'company' : 'companies'} selected
                </span>
            ) : undefined}
        </div>
    );
}
